import { render, staticRenderFns } from "./SetsOverall.vue?vue&type=template&id=472a8ea5&scoped=true&"
import script from "./SetsOverall.vue?vue&type=script&lang=js&"
export * from "./SetsOverall.vue?vue&type=script&lang=js&"
import style0 from "./SetsOverall.vue?vue&type=style&index=0&id=472a8ea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a8ea5",
  null
  
)

export default component.exports